import {
  INIT_GROUP_CHANNEL,
  GROUP_CHANNEL_PROGRESS_START,
  GROUP_CHANNEL_PROGRESS_END,
  GROUP_CHANNEL_LIST_SUCCESS,
  GROUP_CHANNEL_LIST_FAIL,
  GET_GROUP_CHANNEL_SUCCESS,
  GET_GROUP_CHANNEL_FAIL,
  CHANNEL_EDIT_SUCCESS,
  CHANNEL_EDIT_FAIL,
  ADD_GROUP_CHANNEL_ITEM,
  CLEAR_SELECTED_GROUP_CHANNEL,
  GROUP_CHANNEL_CHANGED,
  CREATE_GROUP_CHANNEL_SUCCESS,
  CREATE_GROUP_CHANNEL_FAIL,
  BLOCK_LIST_SUCCESS,
  BLOCK_LIST_FAIL
} from './types'
import {
  sbGetGroupChannelList,
  sbGetGroupChannel,
  sbLeaveGroupChannel,
  sbHideGroupChannel,
  sbCreateGroupChannel,
  sbGetBlockUserList
} from '../../sendbirdActions'

// import SendBird from 'sendbird'
import {areWeInAConversation, getConversationIdFromUrl} from '../../scenes/SendbirdMessenger/util'
import {getMessengerClient} from '../../utils/messenger'

export const initGroupChannel = () => {
  const sb = getMessengerClient()
  for (let channelHandlerId in Object.keys(sb.channelHandlers)) {
    if (channelHandlerId !== 'GLOBAL_CHANNEL_EVENTS') {
      sb.removeChannelHandler(channelHandlerId)
    }
  }
  // sb.removeAllChannelHandlers();
  return {type: INIT_GROUP_CHANNEL}
}

export const groupChannelProgress = start => {
  return {type: start ? GROUP_CHANNEL_PROGRESS_START : GROUP_CHANNEL_PROGRESS_END}
}

export const getBlockUserList = blockedUserListQuery => {
  return dispatch => {
    if (blockedUserListQuery.hasNext) {
      sbGetBlockUserList(blockedUserListQuery)
        .then(blockedUsers => dispatch({type: BLOCK_LIST_SUCCESS, list: blockedUsers}))
        .catch(error => dispatch({type: BLOCK_LIST_FAIL, list: [], error}))
    } else {
      dispatch({type: BLOCK_LIST_FAIL, list: []})
    }
  }
}

export const getGroupChannelList = groupChannelListQuery => {
  return dispatch => {
    dispatch(groupChannelProgress(true))
    if (groupChannelListQuery.hasNext) {
      sbGetGroupChannelList(groupChannelListQuery)
        .then(channels => {
          dispatch({
            type: GROUP_CHANNEL_LIST_SUCCESS,
            list: channels
          })
          dispatch(groupChannelProgress(false))

          // TODO: FIX THIS PLEASE.
          if (areWeInAConversation()) {
            sbGetGroupChannel(getConversationIdFromUrl())
              .then(channel => dispatch({
                type: GET_GROUP_CHANNEL_SUCCESS,
                channel: channel
              }))
              .catch(error => dispatch({type: GET_GROUP_CHANNEL_FAIL, error}))
          }
        })
        .catch(error => {
          dispatch({type: GROUP_CHANNEL_LIST_FAIL, error})
          dispatch(groupChannelProgress(false))
        })
    } else {
      dispatch({type: GROUP_CHANNEL_LIST_FAIL})
      dispatch(groupChannelProgress(false))
    }
  }
}

export const onGroupChannelPress = channelUrl => {
  return dispatch => {
    sbGetGroupChannel(channelUrl)
      .then(channel => dispatch({
        type: GET_GROUP_CHANNEL_SUCCESS,
        channel: channel
      }))
      .catch(error => dispatch({type: GET_GROUP_CHANNEL_FAIL, error}))
  }
}

export const onLeaveChannelPress = channelUrl => {
  return dispatch => {
    sbLeaveGroupChannel(channelUrl)
      .then(response => dispatch({
        type: CHANNEL_EDIT_SUCCESS,
        payload: channelUrl
      }))
      .catch(error => dispatch({type: CHANNEL_EDIT_FAIL, error}))
  }
}

export const onHideChannelPress = channelUrl => {
  return dispatch => {
    sbHideGroupChannel(channelUrl)
      .then(response => dispatch({
        type: CHANNEL_EDIT_SUCCESS,
        payload: channelUrl
      }))
      .catch(error => dispatch({type: CHANNEL_EDIT_FAIL, error}))
  }
}

export const addGroupChannelItem = channel => {
  return {
    type: ADD_GROUP_CHANNEL_ITEM,
    channel: channel
  }
}

export const clearSelectedGroupChannel = () => {
  return {type: CLEAR_SELECTED_GROUP_CHANNEL}
}

export const createGroupChannel = (inviteUserIdList, isDistinct) => {
  return dispatch => {
    sbCreateGroupChannel(inviteUserIdList, isDistinct)
      .then(channel => {
        dispatch({
          type: CREATE_GROUP_CHANNEL_SUCCESS,
          channel: channel
        })
      })
      .catch(error => {
        dispatch({type: CREATE_GROUP_CHANNEL_FAIL, error})
      })
  }
}

export const createGroupChannelListHandler = () => {
  return dispatch => {
    const sb = getMessengerClient()
    let channelHandler = new sb.ChannelHandler()
    channelHandler.onChannelChanged = channel => {
      dispatch({
        type: GROUP_CHANNEL_CHANGED,
        channel: channel
      })
    }
    sb.addChannelHandler('GROUP_CHANNEL_LIST_HANDLER', channelHandler)
  }
}
